import { FiTrash2 } from "react-icons/fi";
import styled from "styled-components";

import { Button } from "../../common/Buttons";
import FlexBox from "../../common/FlexBox";
import { Body2 } from "../../common/Headings";
import { DAVYS_GREY_300, DAVYS_GREY_800, ERROR_RED } from "../../common/colors";

const ModalFooter = styled(FlexBox)`
  border-top: 1px solid ${DAVYS_GREY_300};
  padding: 1rem 1.5rem;
  justify-content: flex-end;
`;

const RemoveConfirmBar = styled(FlexBox)`
  border-top: 1px solid ${DAVYS_GREY_300};
  padding: 1rem 1.5rem;
  justify-content: space-between;
  align-items: center;
  background: ${ERROR_RED[100]};
  gap: 1rem;
`;

const ModalFooterSection = ({
  showRemoveConfirm,
  handleRemoveCustomization,
  showEditingView,
  hasPromptSent,
  isSuccess,
  handleSave,
}) => {
  if (showRemoveConfirm) {
    return (
      <RemoveConfirmBar>
        <FlexBox align="center" columnGap="0.5rem">
          <FiTrash2 size={20} color={ERROR_RED[800]} />
          <Body2 bold color={ERROR_RED[800]}>
            Remove customisation?
          </Body2>
          <Body2 color={DAVYS_GREY_800}>
            This will revert to the default prompt.
          </Body2>
        </FlexBox>
        <Button type="button" onClick={handleRemoveCustomization}>
          REMOVE CUSTOMIZATION
        </Button>
      </RemoveConfirmBar>
    );
  }

  return (
    <ModalFooter>
      <Button
        type="button"
        disabled={showEditingView ? !(hasPromptSent && isSuccess) : true}
        onClick={handleSave}
      >
        SAVE
      </Button>
    </ModalFooter>
  );
};

export default ModalFooterSection;
